<div class="grid-row margin-top-2">
  <section class="grid-col">
    @if (results && results.length > 0 && showResults) {
      <download-modal
        [downloadLink]="downloadLink"
        [isDownloadingResults]="isDownloadingResults"
        [hasError]="hasFetchFailed"
        (action)="startDownload()"
      ></download-modal>

      <!-- Source Information -->
      @if (searchService?.searchType === "RaritySearch") {
        <h4>Source Information:</h4>
        @for (source of sources; track source.Title) {
          <div>
            <span
              ><strong>{{ source.PublicationPlace }}:</strong></span
            >
            <div [innerHTML]="source?.AuthorName"></div>
          </div>
        }

        @if (
          searchService?.searchCriteria?.Locations?.length > 0 &&
          searchService?.searchCriteria.Locations[0].PlantLocationName === "Global"
        ) {
          <p>
            <span><strong>Global</strong></span
            >:
            <a
              class="usa-link usa-link--external"
              href="{{ natureServeURL }}"
              target="_blank"
              rel="noopener noreferrer"
              >NatureServe.</a
            >
            2017.
            <a
              class="usa-link usa-link--external"
              href="{{ conservationStatusURL }}"
              target="_blank"
              rel="noopener noreferrer"
              >Conservation status assessment. Identifying at-risk species and ecosystems.</a
            >
            Arlington, VA.
          </p>
        }
      } @else if (searchService?.searchType === "NoxiousInvasiveSearch") {
        <h4>Source Information:</h4>
        @for (source of sources; track source.Title) {
          <div>
            <span
              ><strong>{{ source.PublicationPlace }}:</strong></span
            >
            <div [innerHTML]="source?.AuthorName"></div>
          </div>
        }
      } @else if (searchService?.searchType === "WetlandSearch") {
        <a class="usa-link" href="{{ plantsHelpDocUrl }}">About the National Wetland Plant List</a>
      } @else if (searchService?.searchType === "ImageSearch") {
        @if (searchService?.searchCriteria.TaxonSearchCriteria !== null) {
          <div>
            <span class="label">Taxonomy: </span>
            {{ searchService?.searchCriteria.TaxonSearchCriteria.Field }} -
            {{ searchService?.searchCriteria.TaxonSearchCriteria.Text }}
          </div>
        }
        @if (
          searchService?.searchCriteria.Countries?.length > 0 &&
          searchService?.searchCriteria.Countries[0].PlantLocationId !== -1
        ) {
          <div>
            <span class="label">Country: </span>
            {{ searchService?.searchCriteria.Countries[0].PlantLocationName }}
          </div>
        }
        @if (searchService?.searchCriteria.Provinces?.length > 0) {
          <div>
            <span class="label">Provinces: </span>
            @for (
              loc of searchService?.searchCriteria.Provinces;
              track loc.PlantLocationId;
              let i = $index
            ) {
              <span>
                {{ loc.PlantLocationName }}
                @if (searchService?.searchCriteria.Provinces.length !== i + 1) {
                  <span>|</span>
                }
              </span>
            }
          </div>
        }
        @if (searchService?.searchCriteria.Counties?.length > 0) {
          <div>
            <span class="label">Counties: </span>
            @for (
              loc of searchService?.searchCriteria.Counties;
              track loc.PlantLocationId;
              let i = $index
            ) {
              <span>
                {{ loc.PlantLocationName }}
                @if (searchService?.searchCriteria.Counties.length !== i + 1) {
                  <span>|</span>
                }
              </span>
            }
          </div>
        }
        @if (searchService?.searchCriteria.Cities?.length > 0) {
          <div>
            <span class="label">Cities: </span>
            @for (
              loc of searchService?.searchCriteria.Cities;
              track loc.PlantLocationId;
              let i = $index
            ) {
              <span>
                {{ loc.PlantLocationName }}
                @if (searchService?.searchCriteria.Cities.length !== i + 1) {
                  <span>|</span>
                }
              </span>
            }
          </div>
        }
        @if (searchService?.searchCriteria.Localities?.length > 0) {
          <div>
            <span class="label">Localities: </span>
            @for (
              loc of searchService?.searchCriteria.Localities;
              track loc.PlantLocationId;
              let i = $index
            ) {
              <span>
                {{ loc.PlantLocationName }}
                @if (searchService?.searchCriteria.Localities.length !== i + 1) {
                  <span>|</span>
                }
              </span>
            }
          </div>
        }
        @if (searchService?.searchCriteria.Artists?.length > 0) {
          <div>
            <span class="label">Artists: </span>
            @for (
              art of searchService?.searchCriteria.Artists;
              track art.DataSourceId;
              let i = $index
            ) {
              <span>
                {{ art.DataSourceString }}
                @if (searchService?.searchCriteria.Artists.length !== i + 1) {
                  <span>|</span>
                }
              </span>
            }
          </div>
        }
        @if (searchService?.searchCriteria.CopyrightStatuses?.length > 0) {
          <div>
            <span class="label">Copyright Status: </span>
            {{ searchService?.searchCriteria.CopyrightStatuses[0].ImageCopyrightName }}
          </div>
        }
        @if (searchService?.searchCriteria.ImageReferences?.length > 0) {
          <div>
            <span class="label">Image Reference: </span>
            {{ searchService?.searchCriteria.ImageReferences[0].ImageReferenceTitle }}
          </div>
        }
        @if (searchService?.searchCriteria.ImageTypes?.length > 0) {
          <div>
            <span class="label">Image Type: </span>
            {{ searchService?.searchCriteria.ImageTypes[0].ImageTypeName }}
          </div>
        }
      }

      <p class="margin-bottom-0">
        Your search matched <strong>{{ numTotalResults }}</strong> records. Only accepted plants are
        included in this count.
        @if (searchService?.searchType !== "ImageSearch") {
          <span> - </span>
        }
        @if (searchService?.searchType !== "ImageSearch") {
          <a
            aria-controls="download-modal"
            class="usa-button usa-button--unstyled"
            (click)="downloadEntireSet()"
            href="#download-modal"
            data-open-modal
          >
            Download Entire Set
          </a>
        }
        @if (searchService?.searchType === "ImageSearch") {
          This includes <strong>{{ numTotalImageCount }}</strong> total images.
        }
      </p>
      @if (numTotalResults > 25) {
        <span>
          Showing <strong>{{ startResultNumber }}</strong> through
          <strong>{{ endResultNumber }}</strong> of <strong>{{ numTotalResults }}</strong> records.
        </span>
      }
      <ul class="usa-list padding-left-0">
        @for (filterOption of selectedFilters; track filterOption.FilterValueId) {
          <li class="display-inline">
            <button
              class="usa-button usa-button--outline button-filter"
              (click)="removeSelectedFilter(filterOption)"
            >
              {{ filterOption.FilterValueName }} <i class="fa fa-times"></i>
            </button>
          </li>
        }
        @if (selectedFilters.length > 1) {
          <li class="display-inline-block">
            <button
              class="usa-button usa-button--unstyled padding-0"
              (click)="clearAllSelectedFilters()"
            >
              Clear All
            </button>
          </li>
        }
      </ul>

      <!-- Allow view type option for Image Search -->
      @if (searchService?.searchType === "ImageSearch") {
        <label class="usa-label" for="viewBy">View By: </label>
        <select class="usa-select" id="viewBy" [(ngModel)]="viewBy" (change)="updateViewBy()">
          <option value="textList">Text List</option>
          <option value="thumbnails">Thumbnails</option>
        </select>
      }

      @if (viewBy === "textList" || searchService?.searchType !== "ImageSearch") {
        <table class="usa-table usa-table--borderless width-full no-borders">
          <caption class="usa-sr-only">
            PLANTS search results
          </caption>
          <thead class="thead-default">
            <tr>
              <th scope="col">
                <button
                  class="usa-button usa-button--unstyled"
                  (click)="sortResults('sortSymbol')"
                  (keyup.enter)="sortResults('sortSymbol')"
                >
                  Symbol
                </button>
              </th>
              <th scope="col">
                <button
                  class="usa-button usa-button--unstyled"
                  (click)="sortResults('sortSciName')"
                  (keyup.enter)="sortResults('sortSciName')"
                >
                  Scientific Name
                </button>
              </th>
              <th scope="col">
                <button
                  class="usa-button usa-button--unstyled"
                  (click)="sortResults('sortCommonName')"
                  (keyup.enter)="sortResults('sortCommonName')"
                >
                  Common Name
                </button>
              </th>
              @if (searchService?.searchType === "WetlandSearch") {
                <th scope="col">Wetland Indicator</th>
              }
              @if (searchService?.searchType === "RaritySearch") {
                <th scope="col">Rarity Status</th>
              }
              @if (searchService?.searchType === "NoxiousInvasiveSearch") {
                <th scope="col">Invasive/Noxious Status</th>
              }
              @if (searchService?.searchType === "FactSheetPlantGuideSearch") {
                <th scope="col">Fact Sheets/Plant Guides</th>
              }
              <th scope="col">
                <span style="display: inline-block; padding-bottom: 5px; padding-top: 5px"
                  >Images</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            @for (result of getSortedResults(results); track result) {
              <tr>
                <th scope="row">
                  <strong>{{ result.Symbol }}</strong>
                </th>
                <td>
                  @if (searchService.searchCriteria.Field === "Family") {
                    <a
                      class="usa-link"
                      [routerLink]="['/plant-profile', result.Symbol]"
                      [queryParams]="{
                        searchName: searchService.searchCriteria.Field
                      }"
                      ><span [innerHTML]="result.ScientificName"></span
                    ></a>
                  }
                  @if (searchService.searchCriteria.Field !== "Family") {
                    <a class="usa-link" [routerLink]="['/plant-profile', result.Symbol]"
                      ><span [innerHTML]="result.ScientificName"></span
                    ></a>
                  }
                </td>
                <td>{{ result.CommonName }}</td>
                @if (searchService?.searchType === "WetlandSearch") {
                  <td>
                    <ul>
                      @for (wetlandData of result.WetlandData; track wetlandData) {
                        <li>
                          {{ getWetlandDataDisplay(wetlandData) }}
                        </li>
                      }
                    </ul>
                  </td>
                }
                @if (searchService?.searchType === "RaritySearch") {
                  <td>
                    <ul>
                      @for (rarityStatus of result.LegalStatuses; track rarityStatus) {
                        <li>
                          {{ getRarityStatusDisplay(rarityStatus) }}
                        </li>
                      }
                    </ul>
                  </td>
                }
                @if (searchService?.searchType === "NoxiousInvasiveSearch") {
                  <td>
                    <ul>
                      @for (noxiousStatus of result.NoxiousStatuses; track noxiousStatus) {
                        <li>
                          {{ getNoxiousStatusDisplay(noxiousStatus) }}
                          <a
                            href="javascript:void(0)"
                            (click)="showNoxiousByState(noxiousStatus.LocalityName)"
                            style="text-align: left"
                            >({{ noxiousStatus.LocalityName }})</a
                          >
                        </li>
                      }
                      @for (invasiveStatus of result.InvasiveStatuses; track invasiveStatus) {
                        <li>
                          {{ getInvasiveStatusDisplay(invasiveStatus) }}
                          <a
                            href="javascript:void(0)"
                            (click)="showInvasiveByState(invasiveStatus.LocalityName)"
                            style="text-align: left"
                            >({{ invasiveStatus.LocalityName }})</a
                          >
                        </li>
                      }
                    </ul>
                  </td>
                }
                @if (searchService?.searchType === "FactSheetPlantGuideSearch") {
                  <td>
                    @if (
                      (result.FactSheetUrls && result.FactSheetUrls.length > 0) ||
                      (result.PlantGuideUrls && result.PlantGuideUrls.length > 0)
                    ) {
                      <ul>
                        @if (result.FactSheetUrls && result.FactSheetUrls.length > 0) {
                          <li>
                            <span>Fact Sheet</span>
                            @for (factSheetUrl of result.FactSheetUrls; track factSheetUrl) {
                              <span
                                ><a
                                  target="_blank"
                                  [href]="factSheetUrl"
                                  rel="noopener noreferrer"
                                  >{{ getDocumentLinkText(factSheetUrl) }}</a
                                ></span
                              >
                            }
                          </li>
                        }
                        @if (result.PlantGuideUrls && result.PlantGuideUrls.length > 0) {
                          <li>
                            <span>Plant Guide</span>
                            @for (plantGuideUrl of result.PlantGuideUrls; track plantGuideUrl) {
                              <span
                                ><a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  [href]="plantGuideUrl"
                                  >{{ getDocumentLinkText(plantGuideUrl) }}</a
                                ></span
                              >
                            }
                          </li>
                        }
                      </ul>
                    }
                  </td>
                }
                <td>
                  @if (result.NumImages > 0) {
                    <span
                      ><i class="fa fa-camera-retro fa-lg display-block" aria-hidden="true"></i>
                      <span>{{ result.NumImages }}</span></span
                    >
                  }
                </td>
              </tr>
              @for (synonymResult of getSortedResults(result.Synonyms); track synonymResult) {
                <tr>
                  <th scope="row" style="padding-left: 2rem">
                    <strong>{{ synonymResult.Symbol }}</strong>
                  </th>
                  <td style="padding-left: 2rem">
                    <span [innerHTML]="synonymResult.ScientificName"></span>
                  </td>
                  <td>{{ synonymResult.CommonName }}</td>
                  @if (searchService?.searchType === "WetlandSearch") {
                    <td>
                      <ul>
                        @for (
                          synonymWetlandData of synonymResult.WetlandData;
                          track synonymWetlandData
                        ) {
                          <li>
                            {{ getWetlandDataDisplay(synonymWetlandData) }}
                          </li>
                        }
                      </ul>
                    </td>
                  }
                  @if (searchService?.searchType === "RaritySearch") {
                    <td>
                      <ul>
                        @for (
                          synonymRarityStatus of synonymResult.LegalStatuses;
                          track synonymRarityStatus
                        ) {
                          <li>
                            {{ getRarityStatusDisplay(synonymRarityStatus) }}
                            <a
                              href="javascript:void(0)"
                              (click)="showRarityByState(synonymRarityStatus.LocalityName)"
                              >({{ synonymRarityStatus.LocalityName }})</a
                            >
                          </li>
                        }
                      </ul>
                    </td>
                  }
                  @if (searchService?.searchType === "NoxiousInvasiveSearch") {
                    <td>
                      <ul>
                        @for (
                          synonymNoxiousStatus of synonymResult.NoxiousStatuses;
                          track synonymNoxiousStatus
                        ) {
                          <li>
                            {{ getNoxiousStatusDisplay(synonymNoxiousStatus) }}
                            <a
                              href="javascript:void(0)"
                              (click)="showNoxiousByState(synonymNoxiousStatus.LocalityName)"
                              >({{ synonymNoxiousStatus.LocalityName }})</a
                            >
                          </li>
                        }
                        @for (
                          synonymInvasiveStatus of synonymResult.InvasiveStatuses;
                          track synonymInvasiveStatus
                        ) {
                          <li>
                            {{ getInvasiveStatusDisplay(synonymInvasiveStatus) }}
                            <a
                              href="javascript:void(0)"
                              (click)="showInvasiveByState(synonymInvasiveStatus.LocalityName)"
                              >({{ synonymInvasiveStatus.LocalityName }})</a
                            >
                          </li>
                        }
                      </ul>
                    </td>
                  }
                  @if (searchService?.searchType === "FactSheetPlantGuideSearch") {
                    <td>
                      @if (
                        (synonymResult.FactSheetUrls && synonymResult.FactSheetUrls.length > 0) ||
                        (synonymResult.PlantGuideUrls && synonymResult.PlantGuideUrls.length > 0)
                      ) {
                        <ul>
                          @if (
                            synonymResult.FactSheetUrls && synonymResult.FactSheetUrls.length > 0
                          ) {
                            <li>
                              <span>Fact Sheet</span>
                              @for (
                                factSheetUrl of synonymResult.FactSheetUrls;
                                track factSheetUrl
                              ) {
                                <span
                                  ><a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    [href]="factSheetUrl"
                                    >{{ getDocumentLinkText(factSheetUrl) }}</a
                                  ></span
                                >
                              }
                            </li>
                          }
                          @if (
                            synonymResult.PlantGuideUrls && synonymResult.PlantGuideUrls.length > 0
                          ) {
                            <li>
                              <span>Plant Guide</span>
                              @for (
                                plantGuideUrl of synonymResult.PlantGuideUrls;
                                track plantGuideUrl
                              ) {
                                <span
                                  ><a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    [href]="plantGuideUrl"
                                    >{{ getDocumentLinkText(plantGuideUrl) }}</a
                                  ></span
                                >
                              }
                            </li>
                          }
                        </ul>
                      }
                    </td>
                  }
                  <td>&nbsp;</td>
                </tr>
              }
            }
          </tbody>
        </table>
      }

      @if (viewBy === "thumbnails" && searchService?.searchType === "ImageSearch") {
        <div class="grid-row margin-top-3">
          @for (result of results; track result) {
            <div class="grid-col-3 text-center">
              <div>
                <a [routerLink]="['/plant-profile', result.Symbol]">
                  <img
                    style="max-height: 100px"
                    [src]="
                      result.ProfileImageFilename
                        ? getPlantImageUrl(result.ProfileImageFilename)
                        : '../../images/image_na.jpg'
                    "
                    alt="thumbnail image of {{ result.ScientificName }}"
                  />
                </a>
              </div>
              <a class="usa-link" [routerLink]="['/plant-profile', result.Symbol]"
                ><span [innerHTML]="result.ScientificName"></span
              ></a>
              <p>{{ result.CommonName }}</p>
            </div>
            @for (synonymResult of result.Synonyms; track synonymResult) {
              <div class="grid-col-3">
                <div class="thumbnail-image">
                  <a [routerLink]="['/plant-profile', result.Symbol]">
                    <img
                      style="max-height: 100px"
                      class="rounded mx-auto d-block img-thumbnail"
                      [src]="
                        synonymResult.ProfileImageFilename
                          ? getPlantImageUrl(synonymResult.ProfileImageFilename)
                          : '../../images/image_na.jpg'
                      "
                      alt="thumbnail image of {{ result.ScientificName }}"
                    />
                  </a>
                </div>
                <div style="text-align: center" class="image-desc">
                  <a [routerLink]="['/plant-profile', synonymResult.Symbol]"
                    ><span [innerHTML]="synonymResult.ScientificName"></span
                  ></a>
                  <p>{{ synonymResult.CommonName }}</p>
                </div>
              </div>
            }
          }
        </div>
      }

      @if (numTotalResults > 25) {
        <plants-pagination
          [page]="page"
          [totalPages]="totalPages"
          (pageChange)="handlePageChange($event)"
        ></plants-pagination>
      }
    }
  </section>
</div>
@if (!results || results.length <= 0) {
  <div class="usa-alert usa-alert--error" role="alert">
    <div class="usa-alert__body">
      <h2 class="usa-alert__heading">No Results Found</h2>
      <p class="usa-alert__text">No results were found based on the search criteria.</p>
      @if (!results || (results.length <= 0 && isError)) {
        <p class="usa-alert__text">
          If you believe you have received this message in error, contact
          <a class="usa-link" href="mailto:plants@ftc.usda.gov">PLANTS</a>
        </p>
      }
    </div>
  </div>
}
